<template>
  <div class="selector-address">
    <div class="address-tree-container">
      <el-tree ref="addressesTree"
               show-checkbox
               node-key="id"
               :data="allAddressList"
               :props="addressProps"
               @check-change="onCheckChange">
      </el-tree>
    </div>
    <div class="operation">
      <div class="desc">已选择<span class="select-number">（{{selectedAddressNum}}）</span>个地区</div>
      <el-button class="btn-white"
                 @click="saveAddress">保存</el-button>
    </div>
  </div>
</template>

<script >
import DBAddress from 'models/db/address.js';
const dbAddress = new DBAddress();
export default {
  props: {
    // 城市数据列表
    allAddressList: {
      type: Array,
      default() {
        return [];
      }
    },
    // 被选中的城市数据列表
    selectedAddressList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      // props配置
      addressProps: {
        label: 'name'
      },
      // 本地被选择的城市列表
      localSelectedAddressList: this.selectedAddressList
    };
  },
  watch: {
    selectedAddressList: {
      deep: true,
      handler(newValue, oldValue) {
        console.log('新传入的城市列表--', newValue);
        this.$refs.addressesTree.setCheckedNodes(newValue);
      }
    }
  },
  computed: {
    selectedAddressNum() {
      // 被选中的城市的数量
      return this.localSelectedAddressList.length;
    }
  },
  methods: {
    onCheckChange() {
      this.localSelectedAddressList =
        this.$refs.addressesTree.getCheckedKeys(true) || [];
    },
    saveAddress() {
      let selectedAddressList =
        this.$refs.addressesTree.getCheckedNodes(true, true) || [];
      let selectedProOrMun = [];
      console.log('选择的节点', selectedAddressList);
      selectedAddressList.map(item => {
        selectedProOrMun.push(item.grandParentName);
      });
      // 然后需要去重
      selectedProOrMun = this._dedeup(selectedProOrMun);
      // 数据传给父组件
      this.$emit('saveAddress', {
        selectedAddressList,
        selectedProOrMun
      });
      // 将tree被选择的节点重置为空
      this.$refs.addressesTree.setCheckedNodes([]);
    },
    _getAddressList() {
      dbAddress
        .getDBAddress()
        .then(res => {
          this.allAddressList = this._removeEmpty(res.result);
        })
        .catch(e => {
          console.log('城市数据--异常', e);
        });
    },
    _removeEmpty(addressList) {
      addressList.map(province => {
        // 第一层 取到单个省的数据
        province.children.map(cityOrDistrict => {
          // 第二层 取到市或者区(区的是因为直辖市)
          if (cityOrDistrict.children.length === 1) {
            cityOrDistrict.children = [];
          }
        });
      });
      return addressList;
    },
    _dedeup(array) {
      return Array.from(new Set(array));
    }
  },
  mounted() {
    // 强制触发一次
    this.$refs.addressesTree.setCheckedNodes(this.selectedAddressList);
  },
  components: {}
};
</script>

<style lang="scss" scoped>
.selector-address {
  width: 100%;
  height: 660px;
  overflow: hidden;
  position: relative;
  .address-tree-container {
    width: 100%;
    height: 560px;
    overflow: auto;
  }
  .operation {
    position: absolute;
    bottom: 0px;
    right: 100px;
    height: 32px;
    font-size: 16px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .desc {
      .select-number {
        color: rgba(61, 116, 242, 1);
      }
    }
    .btn-white {
      margin-left: 20px;
      color: rgba(255, 255, 255, 1);
      border-radius: 4px;
      padding: 8px 10px;
      background: rgba(61, 116, 242, 0.75);
      cursor: pointer;
      &:hover {
        background: rgba(61, 116, 242, 1);
      }
    }
  }
}
</style>

<style lang="scss">
#addressThreeLinkage {
  .el-tree {
    .el-tree-node {
      .el-tree-node__content {
        height: 32px;
      }
    }
  }
}
</style>
